import { useState, useEffect, useRef } from "react"
import { debounce } from "lodash"

const useRibbonHeight = () => {
  const [height, setHeight] = useState(32)
  const visibleRibbonRef = useRef(null)
  const intervalRef = useRef(null)

  // Function to update the height using getBoundingClientRect
  const updateHeight = () => {
    const ribbons = document.querySelectorAll(".ribbon-mobile")

    for (const ribbon of ribbons) {
      if (
        ribbon instanceof HTMLElement &&
        ribbon.offsetParent !== null // checks visibility in layout
      ) {
        visibleRibbonRef.current = ribbon
        break
      }
    }

    if (visibleRibbonRef.current) {
      const rect = visibleRibbonRef.current.getBoundingClientRect()
      const h = Math.floor(rect.height)
      if (h > 0) {
        setHeight(h)
        //console.log("visible ribbon found " + h)
      }

      if (intervalRef.current) {
        //console.log("clearInterval ribbon")
        clearInterval(intervalRef.current)
        intervalRef.current = null
      }
    } else {
      //console.log("No visible ribbon found")
    }
  }

  useEffect(() => {
    const debouncedUpdateHeight = debounce(updateHeight, 100)

    updateHeight()

    intervalRef.current = setInterval(updateHeight, 100)

    window.addEventListener("resize", debouncedUpdateHeight)

    setTimeout(() => {
      if (intervalRef.current) {
        console.info("clearInterval ribbon after 5 seconds")
        clearInterval(intervalRef.current)
        window.removeEventListener("resize", debouncedUpdateHeight)
      }
    }, 5000)

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
      window.removeEventListener("resize", debouncedUpdateHeight)
    }
  }, [])

  return height
}

export default useRibbonHeight
